/**
 *  mouseenter 查看所有取稿人
 */
'use strict';
angular.module('allOpersModule', []).directive('allOpers', ['$timeout', 'trsHttpService',
    function($timeout, trsHttpService) {
        return {
            restrict: 'E',
            scope: {
                showOpers: '=',
                valuekey: '@'
            },
            templateUrl: './resourceCenter/shared/directive/allOpers.html',
            link: function(scope, element, attr) {
                initStatus();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.status = {
                        show: false
                    };
                    if (!scope.showOpers || !scope.showOpers instanceof Array){
                        return;
                    }
                }
            }
        };
    }
]);
